/* // affiche le filename dans js-file-title à l'update
	<label class="contactForm__btn btn btn--black js-file">
		<svg class="icon icon-download" aria-hidden="true"><use xlink:href="#icon-download"/></svg>
		<span class="js-file-withoutTitle">{{ 'contact-us.file.download'|trans }}</span>
		<span class="contactForm__btn-filename js-file-withTitle js-hide">
			<span class="js-file-title"></span>
			<svg class="contactForm__btn-icon icon icon-cross-small js-file-clear" aria-hidden="true"><use xlink:href="#icon-cross-small"/></svg>
		</span>
		<input type="file" id="{{ id }}" name="{{ full_name }}" {{ required ? 'required' : '' }} class="visuallyhidden js-input-file">
	</label>
*/

const inputFile = {

	init: function() {
		$(".js-input-file").change(function(){
			previewFiles(this);
		});
		$(".js-file-clear").click(function(e){
			e.stopPropagation();
			e.preventDefault();
			$(".js-input-file").val(null).change();
		});
		function previewFiles(input){
			let $fileContainer = $(input).closest(".js-file");
			let $fileTitle = $fileContainer.find(".js-file-title");
			let $fileWithoutTitle = $fileContainer.find(".js-file-withoutTitle");
			let $fileWithTitle = $fileContainer.find(".js-file-withTitle");
			$fileWithTitle.addClass("js-hide");
			$fileWithoutTitle.removeClass("js-hide");
			if (input.files && input.files[0]) {
				for (var i = 0; i < input.files.length; i++) {
					readAndPreview(input.files[i], $fileContainer);
				}
			}
		}
		function readAndPreview(file, $fileContainer) {
			let reader = new FileReader();
			let $fileTitle = $fileContainer.find(".js-file-title");
			let $fileWithoutTitle = $fileContainer.find(".js-file-withoutTitle");
			let $fileWithTitle = $fileContainer.find(".js-file-withTitle");
			reader.onload = function (e) {
				if(file){
					$fileTitle.text(file.name);
					$fileWithoutTitle.addClass("js-hide");
					$fileWithTitle.removeClass("js-hide");
				}
			}
			reader.readAsDataURL(file);
		}
	}
}

module.exports = inputFile;